module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drawer drawer-right drawer-map-right dw-xs-10 fold",
    attrs: {
      "id": "drawer-job-details",
      "aria-labelledby": "drawer-job-details",
      "aria-expanded": "true"
    }
  }, [(_vm.value) ? _c('div', {
    staticClass: "drawer-contents"
  }, [_c('div', {
    staticClass: "drawer-heading"
  }, [_c('h3', {
    staticClass: "drawer-title"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" Job Details\n        "), _c('a', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "drawer-body"
  }, [_c('div', {
    staticClass: "job-details"
  }, [(_vm.job && _vm.job.id) ? _c('h4', [_vm._v(_vm._s(_vm.job.user.profile.company_name))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.jobDecorated.number) + " - " + _vm._s(_vm.jobDecorated.quantity) + " " + _vm._s(_vm.jobDecorated.commodity ? _vm.jobDecorated.commodity.name : '–'))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'jobs.show',
        params: {
          id: _vm.value.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link"
  })])], 1), _vm._v(" "), _c('span', {
    staticClass: "job-status text-primary"
  }, [_vm._v(_vm._s(_vm.jobDecorated.status_text))]), _vm._v(" "), _c('job-location', {
    attrs: {
      "location": _vm.jobDecorated.location_from,
      "title": "From"
    }
  }), _vm._v(" "), _c('job-location', {
    attrs: {
      "location": _vm.jobDecorated.location_to,
      "title": "To"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "m-t-lg"
  }, [_vm._v("Progress")]), _vm._v(" "), _c('div', {
    staticClass: "job-overview-details"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar-assigned",
    style: ({
      width: (_vm.progressAssignedPercentage + "%")
    }),
    attrs: {
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": _vm.progressAssignedPercentage,
      "role": "progressbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progressAssignedPercentage) + "% Assigned")])]), _vm._v(" "), (_vm.progressCompletedPercentage > 0) ? _c('div', {
    staticClass: "progress-bar progress-bar-primary",
    style: ({
      width: (_vm.progressCompletedPercentage + "%")
    }),
    attrs: {
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": _vm.progressCompletedPercentage,
      "role": "progressbar"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.progressCompletedPercentage) + "% Complete")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row row-progress-text"
  }, [_c('div', {
    staticClass: "col-xs-4"
  }, [_vm._v("\n            " + _vm._s(_vm.tonnageCompleted) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-center"
  }, [_vm._v("\n            of\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [_vm._v("\n            " + _vm._s(_vm.jobDecorated.quantity) + "\n          ")])]), _vm._v(" "), _c('p', {
    staticClass: "running-total"
  }, [_c('strong', [_vm._v("running total")]), _vm._v(" " + _vm._s(_vm.jobRunningTotal) + "\n        ")])]), _vm._v(" "), _c('h3', {
    staticClass: "m-t-lg"
  }, [_vm._v("Loads")]), _vm._v(" "), _c('ul', {
    staticClass: "list-detail"
  }, _vm._l((_vm.loadsOrderedByLoadingDate), function(load, index) {
    return _c('job-load', {
      key: index,
      attrs: {
        "load": load
      }
    })
  }))], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-655dc9cc"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/JobDetails.vue
// module id = 1025
// module chunks = 0